document.addEventListener('scroll', function () {
    const icon_all = document.querySelectorAll('[data-animated-icon]');
    const stickers_all = document.querySelectorAll('.sticker-svg');


    if (icon_all.length > 0) {
        icon_all.forEach((icon) => {
            let visible = isInViewport(icon) ? 1 : 0;
            let targeted_path = icon.getAttribute('data-animated-icon');
            if (visible) {
                icon.querySelectorAll('path').forEach((element, index) => {
                    let class_add = targeted_path + "_" + index;
                    element.classList.add(class_add);
                    element.style.opacity = '1';
                })
            }
            else {
                icon.querySelectorAll('path').forEach((element, index) => {
                    let class_add = targeted_path + "_" + index;
                    element.classList.remove(class_add);
                    element.style.opacity = '0';
                })
            }
        })

    }

    if (stickers_all.length > 0) {
        stickers_all.forEach((sticker) => {
            let visible = isInViewportForStickers(sticker) ? 1 : 0;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const stickerTop = sticker.offsetTop;
            if (visible) {
                sticker.classList.add('fadeInUp');
                // if (scrollTop > stickerTop) {
                //     sticker.style.backgroundColor = "red";
                // }
            }

        })
    }

});

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= ((window.innerHeight) || (document.documentElement.clientHeight)) &&
        rect.right <= ((window.innerWidth) || (document.documentElement.clientWidth))

    );
}

function isInViewportForStickers(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= ((window.innerHeight - 100) || (document.documentElement.clientHeight - 100)) &&
        rect.right <= ((window.innerWidth) || (document.documentElement.clientWidth))

    );
}

document.querySelectorAll('[data-cta-show-more-details] a').forEach((element) => {
    element.addEventListener('click', function () {
        let contentBlock = element.closest('.tabcontent')?.querySelector('.box-details-wrapper');
        const isOpen = contentBlock.classList.contains('show-more');
        let contentBlockHeight = Utility._getHeightofHiddenEle(contentBlock)
        if (!isOpen) {
            contentBlock.style.height = contentBlockHeight + 'px';
            setTimeout(() => {
                contentBlock.style.height = '';
            }, 300);
            contentBlock.classList.add('show-more');
            element.closest('.tabcontent').classList.add('show-more-wrapper')
        } else {
            contentBlock.style.height = contentBlockHeight + 'px';
            setTimeout(function () {
                contentBlock.style.height = '35' + 'px';
            }, 1);
            setTimeout(function () {
                contentBlock.classList.remove('show-more');
                element.closest('.tabcontent').classList.remove('show-more-wrapper')
            }, 300);

        }
    })
})